
class FieldActivity {
    constructor(routeStopObject){
        //unique identifier
        this.Id = routeStopObject.id; //123456

        this.ModifiedDateTime = null;
        this.CompletedDateTime = null;

        //123 E Example St
        this.Address = routeStopObject.address;
        //has always been null but might be used in future
        this.Comments = routeStopObject.comments;
        //PWREPAIR
        this.ContainerActionType = routeStopObject.containerAction;
        //REPAIR
        this.ContainerActionDisplay = routeStopObject.containerActionDisplay.toUpperCase();
        //1
        this.ContainerCount = routeStopObject.containerCount;
        //90
        this.ContainerSize = routeStopObject.containerSize;
        //REFUSE
        this.ContainerType = routeStopObject.containerType;
        //2021-03-19T09:04:40"
        this.DateCreated = routeStopObject.dateCreated;
        //2021-03-22T00:00:00"
        this.DateScheduled = routeStopObject.dateScheduled;
        //1234567890
        this.FieldActivityId = routeStopObject.fieldActivityId;
        //PWCONT, will always be this unless other types of FA are introduced
        this.Type = routeStopObject.fieldActivityType;
        //ADAMS - 602.444.4444 - 90 Gallon Refuse - BROKEN WHEELS
        this.Instructions = routeStopObject.instructions;
        //33.402693
        this.Latitude = routeStopObject.latitude;
        //-112.017219
        this.Longitude = routeStopObject.longitude;
        //body, lid, or wheels ("" if blank)
        this.PartToRepair = routeStopObject.partToRepair;
        //3
        this.RouteNumber = routeStopObject.routeNumber;
        //15
        this.Sequence = routeStopObject.sequence;
        //1234567890
        this.ServicePoint = routeStopObject.servicePointId;
        //PENDING
        this.Status = routeStopObject.statusDisplay.toUpperCase();
        //bool, instead of using FA Status
        this.ForemanInvestigateFlag = false;
        //String to capture the name of the current user
        this.CompletedBy = '';

        //Holds the int value for the CCB log message sequence
        this.LastLogSequenceNumber = 0;
        //Holds the string value for the log message that will be sent to CC&B
        this.LogMessage = '';
        //Array of FA log messages coming from CC&B
        this.CcbLogMessages = [];
        //REPAIRED
        this.FieldActivityRemark = '';
        //PWREPA
        this.FieldActivityRemarkValue = '';
        //This is a CC&B account property
        this.MainPersonId = '';

        //Bool to specifiy whether or not the FA data is current with CC&B
        this.Synced = false;

        //These props are intented to inform the background worker process
        //Bool to specify that FA needs to update CC&B
        this.NeedsToUpdateCCB = false;
        //Bool to specify that FA needs to update Dynamics
        this.NeedsToUpdateDynamics = false;
        //Bool to specify that FA needs to post log message to CCB
        this.NeedsToPostLog = false;

        //Specific to Dynamics
        //GUID
        this.SolidWasteContainerId = routeStopObject.dynamicsCaseId;
        //GUID (aka incidentId)
        this.ServiceRequestId = routeStopObject.dynamicsRequest;
        //2021-012345
        this.ServiceRequestNumber = routeStopObject.dynamicsServiceRequestNumber;
        //845280000 = OPEN
        this.DynamicsClosureStatus = '';

        //Specific to SharePoint
        //GUID
        this.SharePointPhotoId = '';
        //Img data URI
        this.CnoPhoto = null;

    }
}

export default FieldActivity;